// Turns Markdown footnotes into Tufte sidenotes.
//
// In a Markdown card, write `text[^1]` and `[^1]: The note.` Ghost renders
// <sup class="footnote-ref"><a href="#fn1">[1]</a></sup> and a <section class="footnotes">.
// This moves each note next to its reference as a margin note, with a toggle for small screens.
// Hand-written <span class="sidenote"> and <span class="marginnote"> in HTML cards need no JS.
export default function sidenotes() {
    const content = document.querySelector(".gh-content");
    if (!content) return;
    const refs = content.querySelectorAll("sup.footnote-ref, a.footnote-ref");
    if (!refs.length) return;

    let n = 0;
    refs.forEach((ref) => {
        const link = ref.matches("a") ? ref : ref.querySelector("a");
        if (!link) return;
        const id = (link.getAttribute("href") || "").replace(/^#/, "");
        const note = id && document.getElementById(id);
        if (!note) return;
        n += 1;
        const key = `sn-${n}`;

        const label = document.createElement("label");
        label.setAttribute("for", key);
        label.className = "margin-toggle sidenote-number";
        label.setAttribute("aria-label", `Show note ${n}`);

        const toggle = document.createElement("input");
        toggle.type = "checkbox";
        toggle.id = key;
        toggle.className = "margin-toggle";

        const span = document.createElement("span");
        span.className = "sidenote";
        span.setAttribute("role", "note");
        // copy the note body, dropping the back-reference arrow
        const body = note.cloneNode(true);
        body.querySelectorAll(".footnote-backref").forEach((el) => el.remove());
        // unwrap a single <p> so the note reads inline
        const ps = body.querySelectorAll("p");
        if (ps.length === 1) {
            span.innerHTML = ps[0].innerHTML.trim();
        } else {
            span.innerHTML = body.innerHTML.trim();
        }

        ref.replaceWith(label, toggle, span);
    });

    if (n) {
        content.queridSelectorAll?.(".footnotes, .footnotes-sep");
        content.querySelectorAll(".footnotes, .footnotes-sep, hr.footnotes-sep").forEach((el) => el.remove());
    }
}
